  export const modulesRoles = [
    {
      type: 'link',
      text: 'Dashboard',
      iconLeft: '<i class="mdi mdi-view-dashboard"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Estadísticas',
          path: { name: 'statistics' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
        },

      ],
    },
    {
      type: 'link',
      text: 'Facturas ',
      iconLeft: '<i class="mdi mdi-folder-table"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Reporte',
          path: { name: 'reportInvoices' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          app: ['FE'],
          permission: ['Reporte Facturas']
        },
        {
          type: 'link',
          text: 'Gestión de facturación',
          path: { name: 'managementInvoices' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Gestión Facturación'],
          app: ['FE'],
        },
        {
          type: 'link',
          text: 'Procesamiento ATS',
          path: { name: 'atsProcessing' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Procesamiento ATS'],
          app: ['FE'],
        }
      ],
    },
    {
      type: 'link',
      text: 'Trazabilidad',
      iconLeft: '<i class="mdi mdi-chart-timeline-variant"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Monitoreo de Eventos',
          path: { name: 'wideEventsDashboard' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Trazabilidad'],
        },
        {
          type: 'link',
          text: 'Búsqueda de Eventos',
          path: { name: 'wideEventsSearch' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Trazabilidad'],
        },
        {
          type: 'link',
          text: 'Análisis de Errores',
          path: { name: 'wideEventsErrors' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Trazabilidad'],
        },
      ],
    },
    {
      type: 'link',
      text: 'Administración',
      iconLeft: '<i class="mdi mdi-cogs"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Clientes',
          path: { name: 'clientsConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Configuración Clientes']
        },
        {
          type: 'link',
          text: 'Configuración TEF',
          path: { name: 'tefConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          app: ['TEF'],
          permission: ['Configuración TEF']
        },
        {
          type: 'link',
          text: 'Historial Transacciones TEF',
          path: { name: 'tefTransactionsHistory' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          app: ['TEF'],
          permission: ['Historial Transacciones TEF']
        },
        {
          type: 'link',
          text: 'Firmas Electronicas',
          path: { name: 'firmasConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Firmas Electrónicas']
        },
        {
          type: 'link',
          text: 'Usuarios',
          path: { name: 'userConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Configuración Usuarios']
        },
        {
          type: 'link',
          text: 'Descarga XMLS',
          path: { name: 'downloadXML' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Descarga XMLS']
        },
        {
          type: 'link',
          text: 'Procesar XMLS',
          path: { name: 'loadXML' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Procesar XMLS']
        },
        {
          type: 'link',
          text: 'Logs',
          path: { name: 'Logs' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Logs']
        },
        {
          type: 'link',
          text: 'Parámetros del Sistema',
          path: { name: 'Parametros' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Parámetros Sistema']
        },
      ],
    },
  ]
